function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 403",
  d: "M48.1 124.26c30.43 0 47.6-25.16 47.6-61.88S78.53.5 48.1.5C17.84.5.5 25.66.5 62.38s17.34 61.88 47.6 61.88zm0-22.95c-15.98 0-24.14-13.77-24.14-38.93s8.16-39.1 24.14-39.1 24.31 13.94 24.31 39.1-8.33 38.93-24.31 38.93zm149.77-21.42h-12.75V51.67h-23.63v28.22h-30.94l39.44-77.01h-25.16l-39.61 77.01v21.76h56.27v20.23h23.63v-20.23h12.75z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgNumber04Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.37,
    height: 124.76,
    viewBox: "0 0 198.37 124.76"
  }, props), _ref);
}

export default SvgNumber04Inline;